import React from "react";


const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const normalizeDateString = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

const MonthView = ({ currentDate = new Date(), bookings = [], onDateClick }) => {
  const baseDate =
    bookings.length > 0 ? new Date(bookings[0].admin_date) : currentDate;

  const year = baseDate.getFullYear();
  const month = baseDate.getMonth();

  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  const calendarStart = new Date(firstDay);
  calendarStart.setDate(firstDay.getDate() - firstDay.getDay());

  const calendarEnd = new Date(lastDay);
  calendarEnd.setDate(lastDay.getDate() + (6 - lastDay.getDay()));

  const bookingsByDate = bookings.reduce((acc, item) => {
    acc[item.admin_date] = acc[item.admin_date] || [];
    acc[item.admin_date].push(item);
    return acc;
  }, {});

  const days = [];
  let temp = new Date(calendarStart);
  while (temp <= calendarEnd) {
    days.push(new Date(temp));
    temp.setDate(temp.getDate() + 1);
  }

  return (
    <div className="gc-month">

      <div className="gc-week-header">
        {weekDays.map(day => (
          <div key={day} className="gc-week-day">
            {day}
          </div>
        ))}
      </div>


      <div className="gc-grid">
        {days.map((day, idx) => {
          const dateKey = normalizeDateString(day);
          const dayBookings = bookingsByDate[dateKey] || [];

          return (
            <div
              key={idx}
              className={`gc-cell ${day.getMonth() !== month ? "gc-other-month" : ""
                }`}
              style={{ cursor: "pointer" }}
              onClick={() => onDateClick && onDateClick(new Date(day))}
            >

              <div className="gc-date">{day.getDate()}</div>

              <div className="gc-events">
                {dayBookings.map(item => (
                  <div
                    key={item.consultation_booking_id}
                    className={`gc-event ${item.booking_status}`}
                    title={`${item.category}`}
                    style={{
                      cursor: 'pointer',
                    }} onClick={() => window.open(item.meeting_link, '_blank')}
                  >
                    {item.booking_status === "Rescheduled" && (<span className="gc-event-category">
                      {item.booking_status}
                    </span>
                    )}
                    <span className="gc-event-time">
                      {item.admin_start_time.slice(0, 5)}–{item.admin_end_time.slice(0, 5)}
                    </span>
                    <span className="gc-event-name">
                      {item.full_name || "No Name"}
                    </span>
                  </div>
                ))}

              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MonthView;
